import { gql } from '@apollo/client';

export const VALIDATE_UTILITY_AND_ZIP = gql`
  query Flex_ValidateUtilityAndZip($utilityId: Int, $zipCode: String) {
    validation {
      zipCode(zipCode: $zipCode) {
        isValid
      }
      utility(id: $utilityId) {
        isValid
      }
      zipCodeAndUtility(utilityId: $utilityId, zipCode: $zipCode) {
        isValid
      }
    }
  }
`;
